export const ARTICLE_ARCHIVE_PATHS = {
    ARTICLES: {
        path: '/clanky',
        name: 'ARTICLES_ALL'
    }
} as const;
